export const CLIENT_SIDE_FEATURES = [
    "FLIGHTS_TRAVEL_ALERT",
    "FLIGHTS_ENABLE_APP_DEEPLINKS",
    "FLIGHTS_META_SKYSCANNER_SEND_LANDING_EVENT",
    "FLIGHTS_META_SKYSCANNER_SEND_CONFIRMATION_EVENT",
    "FLIGHTS_MARKETING_BYEAH_SEND_CONFIRMATION_EVENT",
    "FLIGHTS_META_ENABLE_GFS_FOR_POS_MISMATCH",
    "FLIGHTS_EMAIL_XSELL_OPEN_RATE",
    "FLIGHTS_PB_REBOOK_FLOW",
    "FLIGHTS-FE-ET-MISMATCH",
    "FLIGHTS_WEB_BCF_CONSENT_API_V2",
    "FLIGHTS_ENABLE_ANCILLARY_LOW_CONFIDENCE_PREDICTION",
    "FLIGHTS_FUNNEL_EXTRAS_TAX_TITLE_NEW_LOGIC",
    "FLIGHTS_WEB_REPORT_BAGGAGE_QUALITY",
    "FLIGHTS_WEB_PAYMENT_COLLECTION_NEW_PAGE",
    "FLIGHTS_ENABLE_BCOM_INSURANCE_FE_COMPONENT_IN_FLIGHTS_FUNNEL",
    "FLIGHTS_SHOW_SELLABLE_FEATURES",
    "FLIGHTS_PRICING_ENABLE_PREVENT_SUMMING_BCOMPRICINGITEM_IN_PRICE_BREAKDOWN",
    "FLIGHTS_WEB_MP_SHOP_ALLOW_CREDENTIALS",
    "FLIGHTS_ACE_WHITELABEL_ANCILLARY_API",
    "FLIGHTS_ACE_WHITELABEL_ANCILLARY_DISPLAY",
    "FLIGHTS_DISABLE_CALLS_TO_CROSS_SELL_API",
    "FLIGHTS_PRICING_POPULATE_AFFILIATE_ID_FOR_LINK_SHARING",
    "FLIGHTS_A11Y_SWITCH_TO_MOBILE_VIEW",
    "FLIGHTS_WEB_REPORT_SRFD_MISMATCH_METRICS",
    "FLIGHTS_INVOLUNTARY_SCHEDULE_CHANGE_SELF_SERVE",
    "FLIGHTS_WEB_REMOTE_COMPONENT_REDIRECT_AFTER_LOGIN",
    "FLIGHTS_PRICING_ENABLE_PRODUCT_ID_SQUEAK",
    "FLIGHTS_COLLECT_BRANDED_FARE_SUMMARY_DATA",
    "FLIGHTS_E_SIM_BLACK_FRIDAY_CAMPAIGN",
    "FLIGHTS_ASI_GULF_AIRLINES_CHECKED_IN_BAGGAGE_UPDATE",
    "FLIGHTS_MIGRATE_CLIENT_SIDE_BAGGAGE_MERGE_TO_SERVER",
    "FLIGHTS_PRE_OPEN_BRANDED_FARES_DELTA",
    "FLIGHTS_DELTA_DONT_SKIP_FETCH_BRANDED_FARES",
    "FLIGHTS_WEB_CAT_CALENDAR_FIX",
    "FLIGHTS_WEB_CAT_FARE_CALENDAR_CURRENCY_SYMBOLS",
    "DATA_MEASUREMENT_FLIGHTS_WEB_GTM_TAGS",
    "FLIGHTS_WEB_CAT_FLY_ANYWHERE_MAP_REFLOW",
    "FLIGHTS_FARE_RULES_PAID_MISSING_PRICE",
    "FLIGHTS_PRICING_CLEAR_ARIA_LIVE_MESSAGE_AFTER_ANNOUNCEMENT",
    "FLIGHTS_FE_PERIODIC_WARNING_TEST",
    "FLIGHTS_OFFER_HIGHLIGHTS_DRY_RUN",
    "FLIGHTS_WEB_PB_CS_HIGH_VOLUMES_BANNER",
    "FLIGHTS_SEARCH_SUMMARY_V3_DRY_RUN",
    "FLIGHTS_ENABLE_SELLABLE_LOUNGE_ACCESS_EY",
    "FLIGHTS_ENABLE_EXECUTIVE_LOUNGE_ACCESS_UA",
    "FLIGHTS_WEB_WISHLIST_WIDGET_DESKTOP_SSR",
    "FLIGHTS_WEB_SR_OPT_IN_AA_NEETI_TRACKER",
    "FLIGHTS_ASI_WEB_POST_BOOK_MARKETING_EMAIL",
    "FLIGHTS_APEX_WEB_DELTA_FILTER_ON_TOP",
    "FLIGHTS_STRATEGY_MANAGER_ENABLE_INSURANCE_DISCLAIMER_IN_UPB",
    "FLIGHTS_WEB_FD_FORWARD_BASE_OFFER_TOKEN",
    "FLIGHTS_ENABLED_MULTI_WEIGHT_BAGGAGE_OPTION",
    "FLIGHTS_APEX_WEB_C360_PAX_DIGITAL_MEDIA_FIELDS",
    "FLIGHTS_ENABLE_S2S_FEATURE_OVERRIDE_NODE",
    "FLIGHTS_PREVENT_EXTRA_FD_CALL_ON_BRANDED_FARES",
    "FLIGHTS_STRATEGY_MANAGER_INCLUDE_SELECTED_ANCILLARIES_IN_TICKET_TYPE",
    "FLIGHTS_CAR_RENTAL_POC",
    "FLIGHTS_STRATEGY_MANAGER_REPLACE_ACCORDION_IF_NO_BREAKDOWN_ITEM_IN_UPB",
    "FLIGHTS_PB_FIND_ORDER_WITHOUT_PIN",
    "FLIGHTS_FETA_REPLACE_APP_VERSION_MISMATCH_RELOAD",
    "FLIGHTS_WEB_CAT_CALENDAR_OPEN_DEPARTURE_MONTH",
    "FLIGHTS_PB_GEN_AI_CHAT_ASSISTANT_ENABLED",
    "FLIGHTS_C360_FORWARD_ALL_EVENTS",
    "FLIGHTS_PARAMETERIZED_CLIENT_METRICS"
];
export const SERVER_SIDE_FEATURES = [
    "FLIGHTS_PB_FIND_ORDER_WITHOUT_PIN",
    "FLIGHTS_SEND_MOCK_ANCILLARIES_RECOMMENDATION",
    "FLIGHTS_MOCK_RECOMMEND_FLEXIBLE_TICKET",
    "FLIGHTS_MOCK_RECOMMEND_CANCEL_FOR_ANY_REASON",
    "FLIGHTS_MOCK_RECOMMEND_BRANDED_FARE",
    "FLIGHTS_MOCK_RECOMMEND_TRAVEL_INSURANCE",
    "FLIGHTS_C360_SEARCH_ENHANCEMENTS",
    "FLIGHTS_ASI_SEATMAP_ROW_CHARACTERISTIC_ENABLE",
    "FLIGHTS_WEB_CAT_FLY_ANYWHERE_EVENT_FIELDS",
    "FLIGHTS_REPLACE_ORDER_CURRENCY_WITH_SUPPLIER_CURRENCY",
    "FLIGHTS_WEB_REPORT_FLY_ANYWHERE_LIST_COVERAGE",
    "FLIGHTS_WEB_REPORT_FLY_ANYWHERE_MAP_COVERAGE",
    "FLIGHTS_WEB_CAT_FLY_ANYWHERE_RESILIENT_FALLBACK",
    "FLIGHTS_PARAMETERIZED_CLIENT_METRICS"
];
